import Vue from 'vue'

const RbAfterpayPanelAndModal = () =>
  import(
    /* webpackChunkName: "pay-over-time" */ '@/elements/pay-over-time/afterpay/rb-afterpay-panel-and-modal.vue'
  )
Vue.component('rb-afterpay-panel-and-modal', RbAfterpayPanelAndModal)

const RbLensDetailsPanel = () =>
  import(/* webpackChunkName: "pcp-chunk" */ '@/elements/one-configurator/lens-details-panel.vue')
Vue.component('rb-lens-details-panel', RbLensDetailsPanel)

const RbPayOverTime = () =>
  import(/* webpackChunkName: "pay-over-time" */ '@/elements/pay-over-time/rb-pay-over-time.vue')
Vue.component('rb-pay-over-time', RbPayOverTime)

import RbOneConfiguratorTest from '@/elements/one-configurator/one-configurator-test/one-configurator-test.vue'
Vue.component('rb-one-configurator-test', RbOneConfiguratorTest)

import RbPcpPromoStripeWrapper from '@/elements/promo-stripe/rb-pcp-promo-stripe-wrapper.vue'
Vue.component('rb-pcp-promo-stripe-wrapper', RbPcpPromoStripeWrapper)

import RbHeaderPromoStripe from '@/elements/header/promo-stripe/promo-stripe.vue'
Vue.component('rb-header-promo-stripe', RbHeaderPromoStripe)

import RbTextModule from '@/elements/editorial/text-module/rb-text-module.vue'
Vue.component('rb-text-module', RbTextModule)

import RbNewsletterBanner from '@/elements/editorial/cms-layout-variants-wrappers/rb-newsletter-banner/rb-newsletter-banner.vue'
Vue.component('rb-newsletter-banner', RbNewsletterBanner)

import RbCountdown from '@/elements/countdown/rb-countdown.lazy.vue'
Vue.component('rb-countdown', RbCountdown)

const RbCountryOverlay = () =>
  import(
    /* webpackChunkName: "country-selector-chunk" */ '@/elements/footer/country-overlay.lazy.vue'
  )
Vue.component('rb-country-overlay', RbCountryOverlay)

import RbConditionalContent from '@/elements/header/conditional-content/conditional-content.vue'
Vue.component('rb-conditional-content', RbConditionalContent)

import RbConditionalContentWrapper from '@/elements/header/conditional-content/rb-conditional-content-wrapper.vue'
Vue.component('rb-conditional-content-wrapper', RbConditionalContentWrapper)

import RbPromoSubstitute from '@/elements/header/promo-stripe/promo-substitute.vue'
Vue.component('rb-promo-substitute', RbPromoSubstitute)

const RbGenesys = () => import('@/elements/genesys/rb-genesys.vue')
Vue.component('rb-genesys', RbGenesys)

const RbPushNotificationPopup = () =>
  import(
    /* webpackChunkName: "header-popup-chunk" */ '@/elements/push-notification-popup/push-notification-popup.vue'
  )
Vue.component('rb-push-notification-popup', RbPushNotificationPopup)

const RbNewsletterModal = () =>
  import(
    /* webpackChunkName: "header-popup-chunk" */ '@/elements/newsletter-modal/newsletter-modal.lazy.vue'
  )
Vue.component('rb-newsletter-modal', RbNewsletterModal)

import RbPcpAddToBagTrigger from '@/elements/pcp-add-to-bag-trigger/rb-pcp-add-to-bag-trigger.vue'
Vue.component('rb-pcp-add-to-bag-trigger', RbPcpAddToBagTrigger)

import RbMonetate from '@/elements/monetate/rb-monetate.vue'
Vue.component('rb-monetate', RbMonetate)
